import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';

import { GeneralService } from '../../core/utility/general-service/general.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard  {
  currentUrl: string;
  previousUrl: string;
  constructor(private router: Router, private authenticationService: GeneralService) {
    this.router.events
      .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
      .subscribe((events: RoutesRecognized[]) => {
        this.currentUrl = events[1].urlAfterRedirects;
        this.previousUrl = events[0].urlAfterRedirects;
      });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.decode();
    if (currentUser !== undefined && currentUser !== null) {
      return true;
    } else {
      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return false;
    }
  }

}